// src/components/contact/SocialLinks.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFacebook, 
  faXTwitter, 
  faLinkedin, 
  faInstagram, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import './SocialLinks.css'; // Import the custom CSS

const SocialLinks = () => {
  const socialLinks = [
    {
      platform: 'linkedin',
      url: 'https://www.linkedin.com/company/finnovant/',
      icon: faLinkedin,
      color: '#0077b5'
    }
  ];

  return (
    <div className="bmt-social-links-container">
      {socialLinks.map((social) => (
        <a 
          key={social.platform}
          href={social.url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="bmt-social-link"
          style={{ color: social.color }}
        >
          <FontAwesomeIcon 
            icon={social.icon} 
            size="2x"
            className="bmt-social-icon"
            aria-label={`Visit our ${social.platform} page`}
          />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;